import { render } from "./MusicNoteOutline.vue?vue&type=template&id=aa3f86d8"
import script from "./MusicNoteOutline.vue?vue&type=script&lang=js"
export * from "./MusicNoteOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__